// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
// Routing
import { PagesRoutingModule } from './pages-routing.module';
// Modules
import { MedsurfViewerCommonModule } from '../common/medsurf-viewer-common.module';
// Components
import { PagesComponent } from './pages.component';

/**
 * Pages Module
 */
@NgModule({
  imports: [
    // Angular
    CommonModule,
    RouterModule,
    // Routing
    PagesRoutingModule,
    // Modules
    MedsurfViewerCommonModule,
  ],
  declarations: [
    // Components
    PagesComponent
  ],
})
export class PagesModule { }
